import { v4 as uuid } from "uuid";

export const videos = [
  {
    _id: "hjvkhjvk5",
    title: "Is Hiko Really a Baiter?",
    categoryName:"eSports",
    thumbnail:"https://i.ytimg.com/vi/ktiHhN58ALY/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCVGb2uDCTzz0b8B5dnUYrvvW3cjQ",
    videoLink:"https://www.youtube.com/embed/ktiHhN58ALY",
    description:
      "Its not rare in Counter-Strike for certain players to become known for a specific… thing. ",
    creator: "theScore eSports",
    creatorImg:"https://yt3.ggpht.com/ytc/AKedOLSaMOvjLMq79kPHCat1I7bcdq9Mk1eOIgMPjr2a1Q=s88-c-k-c0x00ffffff-no-rj",
    views:"1,333,55"
  },
  {
    _id: "gkjhbkuhvh78",
    title: "Is Hiko Really a Baiter? part 2",
    categoryName:"eSports",
    thumbnail:"https://i.ytimg.com/vi/ktiHhN58ALY/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCVGb2uDCTzz0b8B5dnUYrvvW3cjQ",
    videoLink:"https://www.youtube.com/embed/ktiHhN58ALY",
    description:
      "Its not rare in Counter-Strike for certain players to become known for a specific… thing. ",
    creator: "theScore eSports",
    creatorImg:"https://yt3.ggpht.com/ytc/AKedOLSaMOvjLMq79kPHCat1I7bcdq9Mk1eOIgMPjr2a1Q=s88-c-k-c0x00ffffff-no-rj",
    views:"1,333,55"
  },
  {
    _id: "jlknkbvgcycrxd45",
    title: "The Story of Asuna: Ranked Demon Turned Superstar",
    categoryName:"eSports",
    thumbnail:"https://i.ytimg.com/vi/tP6Fbing6B0/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDU32AWPUZUexHZLDqQ2-QXsIIiJw",
    videoLink:"https://www.youtube.com/embed/tP6Fbing6B0",
    description:
      "In the early days of Valorant, all anyone could talk about was the Counter-Strike and Overwatch converts.  ",
    creator: "theScore eSports",
    creatorImg:"https://yt3.ggpht.com/ytc/AKedOLSaMOvjLMq79kPHCat1I7bcdq9Mk1eOIgMPjr2a1Q=s88-c-k-c0x00ffffff-no-rj",
    views:"2,333,55"
  },
  {
    _id: "mviyhukj00",
    title: "THIS is excellence! | Frenzy Fire EMEA",
    categoryName:"tutorials",
    thumbnail:"https://i.ytimg.com/vi/QqIX5i2gDJI/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCxw-MMa_lZO7zTkBf9_9uOlzrGzw",
    videoLink:"https://www.youtube.com/embed/QqIX5i2gDJI",
    description:
      "In the early days of Valorant, all anyone could talk about was the Counter-Strike and Overwatch converts.  ",
    creator: "VALORANT Champions Tour",
    creatorImg:"https://yt3.ggpht.com/FbK_Krk0qjC7mduy4-p3AHmzGOPnB8FYFVB0XpVlp0ntVwpcxAKoKjnOV8AGxTBauLM37N_m=s88-c-k-c0x00ffffff-no-rj",
    views:"2,333,55"
  },
];
